"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
var type_1 = require("./type");
var stackReducer = function (state, action) {
    if (action.type === type_1.ActionType.SHOW_ADD_FORM) {
        return __assign(__assign({}, state), { showAdd: true });
    }
    if (action.type === type_1.ActionType.HIDE_ADD_FORM) {
        return __assign(__assign({}, state), { showAdd: false });
    }
    if (action.type === type_1.ActionType.SELECT_ROW) {
        if (action.payload === undefined ||
            state.selectedIds.includes(action.payload)) {
            return state;
        }
        return __assign(__assign({}, state), { selectedIds: __spreadArrays(state.selectedIds, [action.payload]) });
    }
    if (action.type === type_1.ActionType.REMOVE_DETAIL) {
        return __assign(__assign({}, state), { selectedIds: state.selectedIds.filter(function (id) { return id !== action.payload; }) });
    }
    if (action.type === type_1.ActionType.DELETE_ITEM) {
        return __assign(__assign({}, state), { selectedIds: state.selectedIds.filter(function (id) { return id !== action.payload; }) });
    }
    return state;
};
exports["default"] = stackReducer;
